import { render, staticRenderFns } from "./ResultDetail.vue?vue&type=template&id=ad91d676&"
import script from "./ResultDetail.vue?vue&type=script&lang=js&"
export * from "./ResultDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports